import { app } from '../../../../../app';
import { Controller } from './all-users.controller';

app.component('companyUserDirectoriesSaaspassUsersAllUsers', {
    bindings: {
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./all-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/all-users.component.js